
export const HOME_PRODUCT_UPDATES = `
  en {
    id
    title
    url
  }
  es {
    id
    title
    url
  }
`;
